import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import DataMapper from "../../components/screens/dataMapper";
import { Layout, Menu } from "antd";
import { SiDatabricks } from "react-icons/si";
import { BsClipboardData } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { useCommonPropertiesContext } from "../../contexts/commonPropertiesContext";
import "./routesNav.css";
import Settings from "../../components/screens/settings";
import { LuClipboardPenLine } from "react-icons/lu";
import Rules from "../../components/screens/rules";
import AddNewRule from "../../components/screens/rules/addNewRule";
import Reports from "../../components/screens/reports";
import Icon from "../../components/masterComponents/Icon";
import Statistics from "../../components/screens/statistics";
import Remapping from "../../components/screens/remapping";
import { GoChecklist } from "react-icons/go";
import { FiFileText } from "react-icons/fi";

const RoutesNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { Sider } = Layout;

  const { isMenuOpen, setIsMenuOpen } = useCommonPropertiesContext();

  const RedirectWithQuery = () => {
    const location = useLocation();
    return <Navigate to={`/data_analyzer${location.search}`} replace />;
  };

  const selectedKey = location.pathname.startsWith("/rules")
    ? "/rules"
    : location.pathname;
  return (
    <div className="app-container">
      <Sider
        collapsible
        reverseArrow
        theme="light"
        className={`custom-sider-btn ${isMenuOpen ? "" : "custom-menu"}`}
        style={{ height: "calc(100vh - 64px)" }}
        collapsed={isMenuOpen}
        onCollapse={() => setIsMenuOpen((prev) => !prev)}
        collapsedWidth={260}
        width={110}
      >
        <Menu
          mode="inline"
          defaultSelectedKeys={["1"]}
          selectedKeys={[selectedKey]}
          inlineCollapsed={false}
          style={{
            backgroundColor: "rgba(179, 172, 172, 0.118)",
            height: "100%",
            textTransform: isMenuOpen ? "capitalize" : "uppercase",
            padding: isMenuOpen ? "var(--spacing-xs)" : 0,
          }}
          className={`${isMenuOpen ? "" : "custom-menu"}`}
          onClick={(info) => {
            navigate(info.key, { replace: false });
          }}
          items={[
            {
              key: "/data_analyzer",
              label: "Data Mapper",
              title: null,
              icon: (
                <Icon
                  icon={SiDatabricks}
                  size={isMenuOpen ? 14 : 18}
                  className="scale-icon"
                />
              ),
            },
            {
              key: "/rules",
              label: "Rules",
              title: null,
              icon: (
                <Icon
                  icon={LuClipboardPenLine}
                  size={isMenuOpen ? 14 : 18}
                  className="scale-icon"
                />
              ),
            },
            {
              key: "/statistics",
              label: "Statistics",
              title: null,
              icon: (
                <Icon
                  icon={BsClipboardData}
                  size={isMenuOpen ? 14 : 18}
                  className="scale-icon"
                />
              ),
            },
            {
              key: "/reports",
              label: "Reports",
              title: null,
              icon: (
                <Icon
                  icon={FiFileText}
                  size={isMenuOpen ? 14 : 18}
                  className="scale-icon"
                />
              ),
            },
             {
              key: "/remapping",
              label: "Remapping",
              title: null,
              icon: (
                <Icon
                  icon={GoChecklist}
                  size={isMenuOpen ? 14 : 18}
                  className="scale-icon"
                />
              ),
            },
            {
              key: "/settings",
              label: "Settings",
              title: null,
              icon: (
                <Icon
                  icon={IoSettingsOutline}
                  size={isMenuOpen ? 14 : 18}
                  className="settings-icon"
                />
              ),
            },
          ]}
        />
      </Sider>

      <Routes>
        <Route path="/" element={<RedirectWithQuery />} />
        <Route path="/data_analyzer" element={<DataMapper />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/rules/add_new" element={<AddNewRule />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/remapping" element={<Remapping />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </div>
  );
};

export default RoutesNav;
